import React from 'react';

import styled from 'styled-components';

import { Partner } from '@customTypes/Partner';
import { PartnerPageTemplate } from '@customTypes/PartnerPageTemplate';
import { TDIs } from '@customTypes/TDI';

interface Props {
  partner: Partner;
  template?: PartnerPageTemplate;
}

const Wrapper = styled.div`
  h5 {
    margin-bottom: 40px;
  }
  .q {
    font-size: 16px;
    position: relative;
    &::before {
      position: absolute;
      content: 'Q';
      left: 0;
    }
    padding-left: 24px;
    color: #2e3035;
    font-weight: 500;
    margin-bottom: 10px;
  }
  .a {
    color: #62656a;
    font-size: 15px;
    font-weight: 400;
    padding-left: 24px;
    margin-bottom: 24px;
    line-height: 160%;
  }
`;

const PartnerFAQ: React.FC<Props> = (props) => {
  const content: TDIs = props.template?.FAQ || [
    {
      title: '사전미팅이 가능한가요?',
      description: '규정에 준하여 채팅과 유선상담만 가능합니다. 결제 후의 미팅은 가능합니다.',
    },
    {
      title: '타 서비스 대비 장점은 무엇인가요?',
      description:
        '다양한 직군의 경력을 지닌 고급 전문가 프리랜서풀을 갖추고 있습니다. 그리고 직접 매칭 요청한 프리랜서뿐 아니라, 매칭매니저가 제안한 프리랜서의 지원서도 확인할 수 있습니다.',
    },
  ];

  return (
    <>
      <Wrapper>
        <h5>자주 묻는 질문</h5>
        {content.map(({ title: q, description: a }, i) => (
          <div key={i}>
            <div className="q">{q}</div>
            <div className="a">{a}</div>
          </div>
        ))}
      </Wrapper>
    </>
  );
};

export default PartnerFAQ;
